import { useState } from "react";
import { useRegisterSW } from "virtual:pwa-register/react";
import { IconClose } from "@veto/ui";
import { requestSafeUpdateCheckpoint } from "../pwaUpdateGate";

/**
 * Service-worker update prompt (vite-plugin-pwa `registerType: "prompt"`).
 * NFR-PWA-004: download → announce → safe checkpoint → activate.
 */
export function ReloadPrompt() {
  const [busy, setBusy] = useState(false);
  const [hint, setHint] = useState<string | null>(null);
  const {
    needRefresh: [needRefresh, setNeedRefresh],
    updateServiceWorker,
  } = useRegisterSW({
    onRegisteredSW(_swUrl, registration) {
      if (!registration) return;
      const hour = 60 * 60 * 1000;
      window.setInterval(() => {
        void registration.update();
      }, hour);
    },
  });

  if (!needRefresh) return null;

  return (
    <div className="pwa-update" role="status" aria-live="polite">
      <span>{hint ?? "A new Veto build is ready."}</span>
      <button
        type="button"
        disabled={busy}
        onClick={() => {
          void (async () => {
            setBusy(true);
            setHint("Checking outgoing messages…");
            const checkpoint = await requestSafeUpdateCheckpoint();
            if (!checkpoint.safe) {
              const proceed = window.confirm(
                `${checkpoint.reason ?? "Outgoing messages still syncing"}. Reload and activate the new build anyway?`,
              );
              if (!proceed) {
                setHint(checkpoint.reason ?? "Waiting for outbox to drain.");
                setBusy(false);
                return;
              }
            }
            setHint("Activating update…");
            await updateServiceWorker(true);
          })();
        }}
      >
        {busy ? "Updating…" : "Reload"}
      </button>
      <button
        type="button"
        className="pwa-close"
        aria-label="Later"
        title="Later"
        disabled={busy}
        onClick={() => setNeedRefresh(false)}
      >
        <IconClose />
      </button>
    </div>
  );
}
